// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.feedlistingmanagement.RentalManagerUserFeedListingManagementV2WebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { CreateManualVersionResponseV2WebDto, CreateManualVersionV2RequestDto } from '../..';

export const RentalManagerUserFeedListingManagementV2WebApiHandler_createManualVersion_Path =
  '/api/web/v2/users/properties/feedListingManagement/createManualVersion';

/**
 * Create manual version of the listing
 */
export const RentalManagerUserFeedListingManagementV2WebApiHandler_createManualVersion = (
  postData: CreateManualVersionV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, CreateManualVersionV2RequestDto, CreateManualVersionResponseV2WebDto>(
    {
      endpoint: RentalManagerUserFeedListingManagementV2WebApiHandler_createManualVersion_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
